export const ADDRESSES_LIMIT = 200;
export const DEFAULT_ADDRESSES_CACHE_AGE: number = 24 * 60 * 60; // SECONDS
export const ADDRESSES_CACHE_MAX_AGE: number =
  Number(process.env.REACT_APP_CACHE_EXPIRATION_TIME) || DEFAULT_ADDRESSES_CACHE_AGE;
